import { FC, useEffect } from 'react';
import { Container, Divider, Stack } from '@mui/material';
import { LoadingBackdrop } from '../../components/loading.backdrop.tsx';
import { Form, Formik } from 'formik';
import { useQuestionsQuery } from '../../graphql/generated/operations/questions.ts';
import { QuestionType } from '../../graphql/generated/graphql.ts';
import { Question } from '../../components/question/question.tsx';
import { SubmitButton } from '../../components/forms/submit.button.tsx';
import { useNavigate } from 'react-router-dom';
import { Paths } from '../../constants/paths.ts';
import * as yup from 'yup';
import { useUpdateUserMutation } from '../../graphql/generated/operations/user.ts';
import { trackEvent } from '../../utils/analytics.ts';

export const StudyQuestionsPage: FC = () => {
  const navigate = useNavigate();
  const [updateUser, { data: onSave, loading: saving }] = useUpdateUserMutation();
  const { data, loading } = useQuestionsQuery({
    variables: {
      type: QuestionType.Onboarding
    }
  });

  useEffect(() => {
    if (onSave) {
      navigate(Paths.MOTIVATION_QUESTIONS);
    }
  }, [onSave]);

  if (loading || saving) {
    return <LoadingBackdrop />;
  }
  return (
    <Container sx={{ mt: 3 }} maxWidth="md">
      <Formik
        validationSchema={yup.object(
          data?.questions.reduce((acc: any, question) => {
            acc[question._id] = yup.string().required('Required');
            return acc;
          }, {})
        )}
        initialValues={{}}
        onSubmit={async (values: any) => {
          trackEvent('study_questions_submit');
          await updateUser({
            variables: {
              user: {
                registrationAnswers: Object.keys(values).map((key: string) => ({
                  questionId: key,
                  response: values[key].toString()
                }))
              }
            }
          });
        }}
      >
        <Form>
          {data?.questions.map((question, index) => (
            <Stack key={question._id} spacing={2}>
              <Question question={question} />
              {index !== data?.questions.length && <Divider />}
            </Stack>
          ))}
          <SubmitButton>Next</SubmitButton>
        </Form>
      </Formik>
    </Container>
  );
};
